<div class="container">
  <section class="pd-tb subscription">
    <div class="headingdiv">
      <h4 class="heading-5">Ease your talent acquisition <a class="orangeText"  href="javascript:void(0)" routerLink="/dashboard">Skip for now</a> </h4>
    </div>
    <ul  class="nav nav-pills sub">
      <li>
        <a href="javascript:void(0)" routerLink="/subscription">Subscription plans</a>
      </li>
      <li class="active"><a href="javascript:void(0)" routerLink="/inventory">Inventory purchase</a>
      </li>
    </ul>
    <p class="para">Purchase clicks and search candidates from the pool as per your requirement</p>
    <form class="text-left pd-tb" [formGroup]="form">
      <div class="row">
         <div class="col-sm-12 selectnumber">
            <p>Select number of clicks and the duration</p>
          </div>
          <div class="col-sm-12 col-lg-5 col-md-5">
            <div class="form-group">
            <label>Duration</label>
            <select class="form-control" (click)="onChange($event)">
              <option> Please select</option>
              <option *ngFor="let duration of allPlans; let i =index;" [value]="duration.id">{{duration.validity}} {{duration.validityType}}</option>
            </select>
          </div>
          </div>

          <div class="col-sm-12 col-lg-5 col-md-5">
            <div class="form-group">
            <label>Number of clicks</label>
            <select class="form-control" readOnly>
              <option>{{clicks!= null ? clicks + " clicks" : "0 clicks"}} </option>
             
             </select>
             </div>
          </div>

          <div class="col-sm-12 col-lg-2 col-md-2 ">
            <div class="form-group">
            <label>Amount</label>
          <p class="amount orangeText">$ {{amount || "0"}}</p>
          </div>
          </div>
        </div>  

        <p class="para6"> <img src="../../../../assets/images/info.svg" class="ht"> Clicks will be counted when a candidate resume is downloaded, candidate profile is forwarded or an email is sent to the candidate.</p>

        <div class="row">
        <div class="col-sm-6 col-lg-6 col-md-6 pt-4">
          <!-- <a href="javascript:void(0);" (click)="redirectTo()" class="planbtn fill" [disabled]="!(form.valid)">Add to cart</a> -->
          <input type="submit" value="Add to cart" (click)="redirectTo()" class="planbtn fill" [disabled]="!(amount)">
      </div>
      </div>
    </form>
  </section> 
</div>
 
  <!-- End -->